import { create } from 'apisauce'

const api = create({
    baseURL: 'https://api.cajamarimoveis.com.br/'
})


export default api